import React from 'react';
import classnames from 'classnames';
import ubBanzai from 'ub/control/banzai-features';

import Toggle from './toggle';
import {TooltipContent} from 'comp/tooltip';

import styles from './breakpoint-button.scss';

export default function BreakpointButton(props) {
  const {
    breakpointName,
    breakpointActive,
    breakpointEnabled,
    showToggle,
    showNotification,
    onClick,
    onToggle,
    onNotificationDismiss,
  } = props;

  const className = classnames(
    'tab',
    'tab-bar-tab',
    'device-mode',
    `device-mode-${breakpointName}`,
    'footer-control',
    'footer-control-button',
    `svg-ico-${breakpointName}`,
    {
      active: breakpointActive,
      [styles.notificationVisible]: showNotification,
    }
  );

  const onClickHandler = ubBanzai.features.isSandboxEnabled() ? null : onClick;

  return (
    <a
      className={className}
      data-role={`${breakpointName}-breakpoint-button`} // required by breakpoint-change-notice
      onClick={onClickHandler}
    >
      {breakpointName.capitalize()}

      {showToggle &&
        <div className={classnames(styles.toggle, 'breakpoint-toggle-switch')}>
          <Toggle value={breakpointEnabled} onChange={onToggle} />

          {showNotification &&
            <TooltipContent className={styles.notification} onDismiss={onNotificationDismiss}>
              You need to have at least one view enabled,
              so we have enabled {breakpointName} for you.
            </TooltipContent>
          }
        </div>
      }
    </a>
  );
}

BreakpointButton.propTypes = {
  breakpointName: React.PropTypes.oneOf(['desktop', 'mobile']).isRequired,
  breakpointActive: React.PropTypes.bool.isRequired,
  breakpointEnabled: React.PropTypes.bool.isRequired,
  showToggle: React.PropTypes.bool.isRequired,
  showNotification: React.PropTypes.bool.isRequired,
  onClick: React.PropTypes.func.isRequired,
  onToggle: React.PropTypes.func.isRequired,
  onNotificationDismiss: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/components/breakpoint-button.jsx